import { Box, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";

export const AccountSettingsFields = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  type = "text",
  multiline = false,
  rows = 1,
}) => {
  return (
    <Box>
      <Typography
        variant="caption"
        color="text.secondary"
        fontWeight={600}
        mb={1}
        mt={3}
      >
        {label}
      </Typography>

      <TextField
        fullWidth
        size="small"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        type={type}
        multiline={multiline}
        rows={multiline ? rows : undefined}
      />
    </Box>
  );
};

AccountSettingsFields.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
};

AccountSettingsFields.defaultProps = {
  value: "",
  placeholder: "-",
  disabled: false,
  name: "",
};
